import script from "./LiquorOrdering.vue?vue&type=script&setup=true&lang=js"
export * from "./LiquorOrdering.vue?vue&type=script&setup=true&lang=js"

import "./LiquorOrdering.vue?vue&type=style&index=0&id=1265dce2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1265dce2"]])

export default __exports__